import {isArrayEmpty, isNullOrUndefined} from "../../../services/Validator";
import CoursesLevelAsVoid from "../../voids/courses/CoursesLevelAsVoid";
import CoursesLevelAItem from "../../items/courses/CoursesLevelAItem";

export default function CoursesLevelAsList({  levelAs,
                                              pickLevelA,
                                              clearLevelAs,
                                              selectedLevelAs }) {
    // Used in CoursesSubthemesContent to
    // display list of flash levels to pick

    // BUILD
    if (isNullOrUndefined(levelAs))
        return null
    if (isArrayEmpty(levelAs))
        return <CoursesLevelAsVoid />
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-3/5 grow flex flex-col justify-start items-center py-[10px] space-y-[6px]"}>
            {levelAs?.map((levelA, index) => (
                <CoursesLevelAItem key={index}
                                   index={index}
                                   total={levelAs.length}
                                   levelA={levelA}
                                   pickLevelA={pickLevelA}
                                   clearLevelAs={clearLevelAs}
                                   selectedLevelAs={selectedLevelAs} />
            ))}
        </div>
    );
}